export default __webpack_public_path__ + "static/media/blueTicket@3x.1b58dd19.png";